import { ArrowLeft } from "lucide-react";
import type { SupportTicketVisibility } from "@/lib/api";
import { AeraButton } from "@/app/components/ui/AeraButton";

export const ticketBackButtonClass =
  "inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-xl border border-aera-lightgray/80 bg-aera-white px-2 py-1.5 text-xs font-semibold text-aera-charcoal transition hover:border-aera-amber hover:bg-aera-warmcream/50 md:gap-2 md:px-3 md:py-2 md:text-sm";

export function ticketBackHref(
  isLoggedIn: boolean,
  visibility: SupportTicketVisibility | undefined,
): string {
  if (isLoggedIn && visibility === "PRIVATE") return "/support/mine";
  return "/support";
}

export function TicketBackButton({
  href,
  label = "กลับ",
  mobileLabel = "กลับ",
  className = "",
}: {
  href: string;
  label?: string;
  mobileLabel?: string;
  className?: string;
}) {
  return (
    <AeraButton
      href={href}
      variant="outline"
      size="xs"
      icon={<ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />}
      className={`shrink-0 ${className}`.trim()}
    >
      <span className="sm:hidden">{mobileLabel}</span>
      <span className="hidden sm:inline">{label}</span>
    </AeraButton>
  );
}

export function isSupportTicketDetailPath(pathname: string): boolean {
  return /^\/support\/tickets\/[^/]+$/.test(pathname);
}

export function isSupportNewPath(pathname: string): boolean {
  return pathname === "/support/new" || pathname.startsWith("/support/new/");
}
